import u from "./ghl-ui.es1589.js";
import p from "./ghl-ui.es1590.js";
import o from "./ghl-ui.es1586.js";
import c from "./ghl-ui.es1587.js";
import f from "./ghl-ui.es1588.js";
import s from "./ghl-ui.es1591.js";
import { Parser as l } from "./ghl-ui.es1670.js";
import { numericPatterns as h } from "./ghl-ui.es1672.js";
import { parseNDigits as v, parseNumericPattern as P } from "./ghl-ui.es1671.js";
var w = /* @__PURE__ */ function(m) {
  c(a, m);
  var n = f(a);
  function a() {
    var i;
    u(this, a);
    for (var r = arguments.length, t = new Array(r), e = 0; e < r; e++)
      t[e] = arguments[e];
    return i = n.call.apply(n, [this].concat(t)), s(o(i), "priority", 60), s(o(i), "incompatibleTokens", ["t", "T"]), i;
  }
  return p(a, [{
    key: "parse",
    value: function(r, t, e) {
      switch (t) {
        case "m":
          return P(h.minute, r);
        case "mo":
          return e.ordinalNumber(r, {
            unit: "minute"
          });
        default:
          return v(t.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, t) {
      return t >= 0 && t <= 59;
    }
  }, {
    key: "set",
    value: function(r, t, e) {
      return r.setUTCMinutes(e, 0, 0), r;
    }
  }]), a;
}(l);
export {
  w as MinuteParser
};
